





























































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import Excel from "exceljs";
import { firebase } from "@/config/firebase";
import { Contrato, Contratos } from "@/typings/store/plugins/easyFirestore/contratos";
import { Cliente } from "@/typings/store/plugins/easyFirestore/clientes";
import { Local } from "@/typings/store/plugins/easyFirestore/locales";
import {
  COLUMNAS_CONTRATOS,
  EJEMPLO_CONTRATO,
  construirContrato,
} from "@/helpers/contratosExcel";

const MAX_FILAS = 500;

@Component({
  validations: {
    archivo: { required },
  },
})
export default class CargarExcel extends Vue {
  @Prop() readonly contratos!: Contratos;
  @Prop({ default: () => [] }) readonly clientes!: Cliente[];
  @Prop({ default: () => [] }) readonly locales!: Local[];

  archivo: Blob | null = null;
  cargando = false;
  clickCargar = false;

  despachos: Array<Contrato> = [];
  mensajes: Array<string> = [];
  mensajesEsError = false;

  async descargarPlantilla(): Promise<void> {
    const workbook = new Excel.Workbook();
    const sheet = workbook.addWorksheet("Contratos", { properties: { defaultColWidth: 18 } });
    sheet.addRow([...COLUMNAS_CONTRATOS]);
    sheet.addRow(EJEMPLO_CONTRATO);
    const nota = sheet.addRow([
      "Borra la fila de ejemplo. cliente = RUT o código del cliente; local = código del local; fechas DD-MM-AAAA; superficie vacía = la del local.",
    ]);
    nota.font = { italic: true, color: { argb: "FF666666" } };
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "plantilla_contratos.xlsx";
    link.click();
  }

  get archivoError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.archivo.$dirty) return errors;
    if (!this.$v.archivo.required) errors.push("Requerido");
    return errors;
  }

  @Emit("carga-excel")
  onCargaExcel(): Array<Contrato> {
    return this.despachos;
  }

  reintentar(): void {
    this.clickCargar = false;
    this.mensajes = [];
    this.mensajesEsError = false;
    this.despachos = [];
  }

  async cargar(): Promise<void> {
    this.$v.$touch();
    if (this.$v.$invalid || !this.archivo) return;
    this.cargando = true;
    this.clickCargar = true;
    this.mensajes = [];
    this.mensajesEsError = false;
    this.despachos = [];

    try {
      const workbook = new Excel.Workbook();
      await workbook.xlsx.load(await this.archivo.arrayBuffer());
      const worksheet = workbook.getWorksheet(1);
      if (worksheet.actualRowCount - 1 > MAX_FILAS) {
        this.mensajes.push(`El archivo tiene más de ${MAX_FILAS} filas.`);
        this.mensajesEsError = true;
        return;
      }

      const encabezado = ((worksheet.getRow(1).values as unknown[]) || []).slice(1).map(String);
      if (encabezado.slice(0, COLUMNAS_CONTRATOS.length).join("|") !== COLUMNAS_CONTRATOS.join("|")) {
        this.mensajes.push("Las columnas no coinciden con la plantilla. Descarga la plantilla nueva y vuelve a intentar.");
        this.mensajesEsError = true;
        return;
      }

      const codigosUsados = new Set(Object.values(this.contratos || {}).map((c) => Number(c.codigo)));
      const errores: string[] = [];
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;
        const fila = (row.values as unknown[]).slice(1);
        const primera = String(fila[0] ?? "").trim();
        if (!primera || primera.startsWith("Borra la fila")) return; // filas vacías o la nota
        const resultado = construirContrato(fila, {
          clientes: this.clientes,
          locales: this.locales,
          codigosUsados,
        });
        if ("errores" in resultado) {
          errores.push(`Fila ${rowNumber}: ${resultado.errores.join("; ")}`);
          return;
        }
        const c = resultado.contrato;
        codigosUsados.add(c.codigo);
        this.despachos.push({
          ...c,
          fechaInicio: firebase.firestore.Timestamp.fromDate(c.fechaInicio),
          fechaFin: firebase.firestore.Timestamp.fromDate(c.fechaFin),
        } as unknown as Contrato);
      });

      if (errores.length) {
        // Todo o nada: si hay errores no se carga ninguna fila.
        this.mensajesEsError = true;
        this.mensajes = [...errores, "No se cargó ningún contrato. Corrige el Excel y vuelve a intentar."];
        this.despachos = [];
        return;
      }
      if (!this.despachos.length) {
        this.mensajesEsError = true;
        this.mensajes = ["El archivo no tiene filas de contratos."];
        return;
      }
      this.mensajes = [`${this.despachos.length} contratos cargados.`];
      this.onCargaExcel();
    } catch (error) {
      this.mensajesEsError = true;
      this.mensajes = ["No se pudo leer el archivo. ¿Es un .xlsx?"];
      if (process.env.NODE_ENV !== "production") console.error(error);
    } finally {
      this.cargando = false;
    }
  }
}
